/**
 * Normalisation française de base, isolée de `tokenize-fr` pour que `wordlists-fr`
 * puisse s'en servir sans dépendance circulaire (les listes sont normalisées à la
 * construction : toutes les comparaisons portent sur des tokens déjà repliés).
 */

/** Minuscules, sans accents, apostrophes et ligatures neutralisées. */
export function normalizeFr(text: string): string {
  return text
    .toLowerCase()
    .replace(/[’‘ʼ`´]/g, "'")
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
